<template>
  <svg
    version="1.2"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    overflow="visible"
    preserveAspectRatio="none"
    viewBox="0 0 22 22"
    :height="height"
    :width="width"
  >
    <g transform="translate(1, 1)">
      <g
        fill-rule="evenodd"
        fill="none"
        stroke-width="1"
        stroke="none"
        id="Domain-Managment_1614620413853"
      >
        <g
          :fill="color"
          transform="translate(-939.000000, -122.000000)"
          id="Learner-Info/Add-Empty_1614620413853"
        >
          <g id="popup_1614620413853">
            <g
              transform="translate(225.000000, 96.000000)"
              id="window_1614620413853"
            >
              <g
                transform="translate(712.000000, 24.000000)"
                id="icon/popular/close_1614620413853"
              >
                <path
                  id="Combined-Shape_1614620413853"
                  d="M12,10.9121434 L20.6868409,2.22530248 C20.9872442,1.92489917 21.4742942,1.92489917 21.7746975,2.22530248 C22.0751008,2.52570578 22.0751008,3.01275576 21.7746975,3.31315906 L13.0878566,12 L21.7746975,20.6868409 C22.0751008,20.9872442 22.0751008,21.4742942 21.7746975,21.7746975 C21.4742942,22.0751008 20.9872442,22.0751008 20.6868409,21.7746975 L12,13.0878566 L3.31315906,21.7746975 C3.01275576,22.0751008 2.52570578,22.0751008 2.22530248,21.7746975 C1.92489917,21.4742942 1.92489917,20.9872442 2.22530248,20.6868409 L10.9121434,12 L2.22530248,3.31315906 C1.92489917,3.01275576 1.92489917,2.52570578 2.22530248,2.22530248 C2.52570578,1.92489917 3.01275576,1.92489917 3.31315906,2.22530248 L12,10.9121434 Z"
                  vector-effect="non-scaling-stroke"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "CloseIcon",
  props: {
    width: {
      type: String,
      default() {
        return "20";
      },
    },
    height: {
      type: String,
      default() {
        return "20";
      },
    },
    color: {
      type: String,
      default() {
        return "#256AB3";
      },
    },
  },
};
</script>

<style scoped>
</style>
